<template>
    <div class="page">
        <div class="second-header-wrap">
            <el-select v-model="currentNotice" @change="noticeChange" placeholder="请选择">
                <el-option
                    v-for="noticeItem in noticeList"
                    :key="noticeItem.id"
                    :label="noticeItem.title"
                    :value="noticeItem.id">
                </el-option>
            </el-select>
        </div>
        <div class="row">
            <div class="accounting job-accounting" v-show="jobData && jobData.length !== 0">
                <div class="header">
                    <span class="color-block"></span>
                    家长职业类型统计
                </div>
                <div class="data-chart" id="job-chart">
                </div>
                <div class="data-container">
                    <div class="data-item" v-for="item in jobData">
                        <span class="data-item__desc">{{item.dutyTypeName}}</span>
                        <span class="data-item__data">{{item.enrolCount}}</span>
                    </div>
                </div>
<!--                <default-page v-show="jobData && jobData.length === 0"></default-page>-->
            </div>
            <div class="accounting edu-accounting" v-show="eduData && eduData.length !== 0">
                <div class="header">
                    <span class="color-block"></span>
                    家长学历统计
                </div>
                <div class="data-chart" id="edu-chart">
                </div>
                <div class="data-container">
                    <div class="data-item" v-for="item in eduData">
                        <span class="data-item__desc">{{item.education}}</span>
                        <span class="data-item__data">{{item.enrolCount}}</span>
                    </div>
                </div>
<!--                <default-page v-show="eduData && eduData.length === 0"></default-page>-->
            </div>
        </div>
        <div class="row">
            <div class="accounting area-accounting" v-show="areaData && areaData.length !== 0">
                <div class="header">
                    <span class="color-block"></span>
                    施教区统计
                </div>
                <div class="data-chart" id="area-chart">
                </div>
            </div>
            <div class="accounting gra-accounting" v-show="graData && graData.length !== 0">
                <div class="header">
                    <span class="color-block"></span>
                    毕业学校统计
                </div>
                <div class="data-chart" id="gra-chart">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DefaultPage from '@/components/DefaultPage';
    import moment from 'moment';
    import echarts from 'echarts';

    import {
        getSchoolEnrolNoticeList,
        getStaterunEnrolDutyTypeAnalysisDatas,
        getStaterunEnrolTeachAreaAnalysisDatas,
        getStaterunEnrolGraduateSchoolAnalysisDatas,
        getStaterunEnrolEduValAnalysisDatas
    } from '@/api/primary/accounting';

    function drawPieChart(containerId, config) {
        const option = {
            color: [
                "#3fb1e3",
                "#6be6c1",
                "#626c91",
                "#a0a7e6",
                "#c4ebad",
                "#96dee8"
            ],
            avoidLabelOverlap: true,
            tooltip : {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
                data: config.data.map(item => item.name)
            },

            series : [
                {
                    name: config.seriesName,
                    type: 'pie',
                    radius : '65%',
                    center: ['50%', '50%'],
                    data: config.data,
                    label: {
                        normal: {
                            position: config.labelInside ? 'inside' : 'outside',
                            color: '#333',
                            formatter: function(value) {
                                if(value.name.length > 4) {
                                    return `${value.name.slice(0, 4)}\n${value.name.slice(4)}`
                                } else {
                                    return value.name;
                                }
                            }
                        }
                    },
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };

        if (document.getElementById(containerId) !== null) {
            echarts.init(document.getElementById(containerId)).setOption(option);
        }
    }
    function drawBarChart(containerId, config) {
        const option = {
            color: ['#3fb1e3'],
            dataZoom: {
                zoomLock: true,
                show: config.isNoZoom ? false : config.xAxisData.length > 5,
                realtime: true,
                start: 0,
                end: config.isNoZoom ? 100 : 100 / config.xAxisData.length * 5 > 100 ? 100 : 100 / config.xAxisData.length * 5,
                showDetail: false
            },
            tooltip : {
                trigger: 'axis',
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis : [
                {
                    axisLabel: {
                        interval: 0,
                    },
                    type : 'category',
                    data : config.xAxisData
                }
            ],
            yAxis : [
                {
                    name: config.yAxisName,
                    type : 'value',
                    minInterval: 1
                }
            ],
            series : [
                {
                    name: config.seriesName,
                    type:'bar',
                    barWidth: '50%',
                    data: config.data,
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                }
            ]
        };

        if (document.getElementById(containerId) !== null) {
            echarts.init(document.getElementById(containerId)).setOption(option);
        }
    }

    export default {
        name: "SignupAccounting",
        data() {
            return {
                currentNotice: 0,
                noticeList: [],
                jobData: [],
                areaData: [],
                graData: [],
                eduData: []
            }
        },
        components: {DefaultPage},
        mounted() {
            getSchoolEnrolNoticeList({
                searchVal: '',
                state: 2
            })
                .then(res => res.data)
                .then(data => {
                    this.noticeList = data.data;
                    if(data.data.length !== 0) {
                        this.currentNotice = data.data[0].id;
                        this.getStaterunEnrolDutyTypeAnalysisDatasFunc();
                        this.getStaterunEnrolTeachAreaAnalysisDatasFunc();
                        this.getStaterunEnrolGraduateSchoolAnalysisDatasFunc();
                        this.getStaterunEnrolEduValAnalysisDatasFunc();
                    }
                });
        },
        methods: {
            noticeChange() {
                this.getStaterunEnrolDutyTypeAnalysisDatasFunc();
                this.getStaterunEnrolTeachAreaAnalysisDatasFunc();
                this.getStaterunEnrolGraduateSchoolAnalysisDatasFunc();
                this.getStaterunEnrolEduValAnalysisDatasFunc();
            },
            getStaterunEnrolEduValAnalysisDatasFunc() {
                getStaterunEnrolEduValAnalysisDatas({
                    noticeId: this.currentNotice
                })
                    .then(res => res.data)
                    .then(data => {
                        const pageData = data.data;
                        this.eduData = pageData;
                        const seriesData = pageData.map(({education, enrolCount}) => ({
                            name: education,
                            value: enrolCount
                        }));
                        drawPieChart('edu-chart', {
                            seriesName: '人数',
                            data: seriesData
                        });
                    })
            },
            getStaterunEnrolDutyTypeAnalysisDatasFunc() {
                getStaterunEnrolDutyTypeAnalysisDatas({
                    noticeId: this.currentNotice
                })
                    .then(res => res.data)
                    .then(data => {
                        const pageData = data.data;
                        this.jobData = pageData;
                        const seriesData = pageData.map(({dutyTypeName, enrolCount}) => ({
                            name: dutyTypeName,
                            value: enrolCount
                        }));
                        drawPieChart('job-chart', {
                            seriesName: '人数',
                            data: seriesData
                        });
                    })
            },
            getStaterunEnrolTeachAreaAnalysisDatasFunc() {
                getStaterunEnrolTeachAreaAnalysisDatas({
                    noticeId: this.currentNotice
                })
                    .then(res => res.data)
                    .then(data => {
                        const pageData = data.data;
                        this.areaData = pageData;
                        const xAxisData = [],
                            seriesData = [];
                        pageData.forEach(({teachAreaName, enrolCount}) => {
                            xAxisData.push(teachAreaName);
                            seriesData.push(enrolCount);
                        });
                        drawBarChart('area-chart', {
                            yAxisName: '人数',
                            xAxisData,
                            seriesName: '人数',
                            data: seriesData
                        });
                    })
            },
            getStaterunEnrolGraduateSchoolAnalysisDatasFunc() {
                getStaterunEnrolGraduateSchoolAnalysisDatas({
                    noticeId: this.currentNotice
                })
                    .then(res => res.data)
                    .then(data => {
                        const pageData = data.data;
                        this.graData = pageData;
                        const xAxisData = [],
                            seriesData = [];
                        pageData.forEach(({graduateSchool, enrolCount}) => {
                            xAxisData.push(graduateSchool);
                            seriesData.push(enrolCount);
                        });
                        drawBarChart('gra-chart', {
                            yAxisName: '人数',
                            xAxisData,
                            seriesName: '人数',
                            data: seriesData
                        });
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";

    @include globalstyle;

    .page {
        padding: 15px;
    }

    .row {
        clear: both;
    }
    .header {
        font-size: 18px;
        border-bottom: 1px solid #20a0ff;
        width: 250px;
        .color-block {
            @include wh(20px, 20px);
            @include middleIB;
            background-color: #20a0ff;
            margin-right: 5px;
        }
        white-space: nowrap;
        margin: 10px 5px 10px 0;
        padding: 0 0 10px 0;
    }
    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 0;
        background-color: #fff;
        z-index: 1000;
    }
    .data-container {
        width: 400px;
        box-sizing: border-box;
        border: 1px solid #409EFF;
        border-radius: 10px;
        padding: 20px;
        font-size: 18px;
        span {
            @include middleIB;

        }
        .data-item__desc {
            width: 70%;
        }
        .data-item__data {
            width: 28%;
        }
    }
    .job-accounting, .edu-accounting {
        float: left;
        width: 700px;
        margin-right: 10px;
        .data-chart {
            float: left;
            width: 450px;
            height: 450px;

        }
        .data-container {
            width: 220px;
            float: left;
        }
        .data-item__desc {
            width: 68%;
        }
    }
    .area-accounting {
        float: left;
        width: 700px;
        .data-chart {
            width: 700px;
            height: 500px;
        }
    }
    .gra-accounting {
        float: left;
        width: 700px;
        .data-chart {
            width: 700px;
            height: 500px;
        }
    }
    .accounting {
        @include clearfix;
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/accounting/SignupAccounting.vue